import { HotelSearchPage } from '@frontend/features/hotels/HotelSearchPage';
import { hotelSearchTransport } from '@frontend/features/hotels/hotelSearchTransport';

import { BookingCaseContextProvider } from '@frontend/features/travel-services/components/BookingCaseContext';

export const Hotels = () => {
  return (
    <BookingCaseContextProvider>
      <HotelSearchPage transport={hotelSearchTransport} />
    </BookingCaseContextProvider>
  );
};
